import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;

export const ApprovelFilterData = createAsyncThunk(
    'OrderApproval/ApprovelFilterData',
    async (_, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');

            const response = await axios.post(`${BaseURL}/Approver/ApprovelFilterData`, {
                DataBase: DataBase
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const GetOrderApprovalData = createAsyncThunk(
    'OrderApproval/GetOrderApprovalData',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const SqlId = Cookies.get('SqlId');
            const AcYearIDs = Cookies.get('FinancialYear');

            const response = await axios.post(`${BaseURL}/Approver/GetOrderApprovalData`, {
                ...data,
                DataBase: DataBase,
                SqlId: data.SqlId || SqlId,
                AcYearIDs: data.AcYearIDs || AcYearIDs
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return { ...response.data, option: data.Option };
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

export const PostOrderApproval = createAsyncThunk(
    'OrderApproval/PostOrderApproval',
    async (data, { rejectWithValue }) => {
        try {
            const token = Cookies.get('authToken');
            const DataBase = Cookies.get('Database');
            const SqlId = Cookies.get('SqlId');
            const AcYearIDs = Cookies.get('FinancialYear');

            const response = await axios.post(`${BaseURL}/Approver/PostOrderApproval`, {
                ...data,
                DataBase: DataBase,
                SqlId: data.SqlId || SqlId,
                AcYearIDs: data.AcYearIDs || AcYearIDs
            }, {
                headers: {
                    token: token,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : 'Network Error');
        }
    }
);

const orderApprovalSlice = createSlice({
    name: 'OrderApproval',
    initialState: {
        filterData: null,
        poList: [],
        orderDetails: [],
        historyData: [],
        loading: false,
        detailsLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(ApprovelFilterData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ApprovelFilterData.fulfilled, (state, action) => {
                state.loading = false;
                state.filterData = action.payload;
            })
            .addCase(ApprovelFilterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(GetOrderApprovalData.pending, (state, action) => {
                if (action.meta.arg.Option === '0') {
                    state.loading = true;
                } else {
                    state.detailsLoading = true;
                }
                state.error = null;
            })
            .addCase(GetOrderApprovalData.fulfilled, (state, action) => {
                state.loading = false;
                state.detailsLoading = false;
                state.poList = action.payload.data;
                state.orderDetails = action.payload.data1;
                state.historyData = action.payload.data2;
            })
            .addCase(GetOrderApprovalData.rejected, (state, action) => {
                state.loading = false;
                state.detailsLoading = false;
                state.error = action.payload;
            });
    },
});

export default orderApprovalSlice.reducer;
